import { useState, useEffect } from 'react';
import { useFilePicker } from 'use-file-picker';
import { FileSizeValidator } from 'use-file-picker/validators';
import { trackActivity } from '../utils/analytics/analyticsService';

const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024;

const useChatFiles = () => {
  const [stagedFile, setStagedFile] = useState(null);

  const {
    openFilePicker: openFileSelector,
    plainFiles,
    filesContent,
    clear
  } = useFilePicker({
    accept: ['.pdf', '.jpg', '.jpeg', '.png', '.tif', '.tiff', '.csv', '.xlsx'],
    multiple: false,
    readAs: 'DataURL',
    validators: [new FileSizeValidator({ maxFileSize: MAX_FILE_SIZE_BYTES })]
  });

  const onClose = () => {
    clear();
    setStagedFile(null);
  };

  useEffect(() => {
    if (plainFiles.length > 0) {
      trackActivity('messaging: file upload staged', { filename: plainFiles[0].name, fileType: plainFiles[0].type });

      const file = plainFiles[0];
      setStagedFile(file);
    }
  }, [plainFiles, filesContent]);

  return { stagedFile, setStagedFile, openFileSelector, onClose, clear, plainFiles, filesContent };
};

export default useChatFiles;
